export const CONTRACT_INTERACTION = 'contract-interaction';
export var FeeDataKey;
(function (FeeDataKey) {
    FeeDataKey["Slow"] = "slow";
    FeeDataKey["Average"] = "average";
    FeeDataKey["Fast"] = "fast";
})(FeeDataKey || (FeeDataKey = {}));
export var ValidAddressResultType;
(function (ValidAddressResultType) {
    ValidAddressResultType["Valid"] = "valid";
    ValidAddressResultType["Invalid"] = "invalid";
})(ValidAddressResultType || (ValidAddressResultType = {}));
export var ChainAdapterDisplayName;
(function (ChainAdapterDisplayName) {
    ChainAdapterDisplayName["Thorchain"] = "THORChain";
    ChainAdapterDisplayName["Mayachain"] = "MAYAChain";
    ChainAdapterDisplayName["Ethereum"] = "Ethereum";
    ChainAdapterDisplayName["Avalanche"] = "Avalanche C-Chain";
    ChainAdapterDisplayName["Optimism"] = "Optimism";
    ChainAdapterDisplayName["BnbSmartChain"] = "BNB Smart Chain";
    ChainAdapterDisplayName["Polygon"] = "Polygon";
    ChainAdapterDisplayName["Gnosis"] = "Gnosis";
    ChainAdapterDisplayName["Arbitrum"] = "Arbitrum One";
    ChainAdapterDisplayName["ArbitrumNova"] = "Arbitrum Nova";
    ChainAdapterDisplayName["Base"] = "Base";
    ChainAdapterDisplayName["Cosmos"] = "Cosmos";
    ChainAdapterDisplayName["Bitcoin"] = "Bitcoin";
    ChainAdapterDisplayName["BitcoinCash"] = "Bitcoin Cash";
    ChainAdapterDisplayName["Dogecoin"] = "Dogecoin";
    ChainAdapterDisplayName["Litecoin"] = "Litecoin";
    ChainAdapterDisplayName["Solana"] = "Solana";
})(ChainAdapterDisplayName || (ChainAdapterDisplayName = {}));
